module.exports = __webpack_public_path__ + "media/svg-new/parchment-d3e662cd.svg";